// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

const messages = {
  en: {
    ...enLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
  },
  zh_cn: {
    ...zhLocale // 或者用 Object.assign({ message: '你好' }, zhLocale)
  }
}
Vue.prototype.$curLang = 'zh_cn'

const i18n = new VueI18n({
  locale: Vue.prototype.$curLang, // set locale
  messages // set locale messages
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js